module.exports = __webpack_public_path__ + "static/media/cpp.c59421e8.svg";